import React, { useRef } from 'react'
import classNames from 'classnames'
import { CaptionXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export interface DateInputProps {
  label: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  required?: boolean
  min?: string
  max?: string
  name?: string
  disabled?: boolean
  error?: string
}

export const DateInput: React.FC<DateInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  required = false,
  min,
  max,
  name,
  disabled = false,
  error,
}) => {
  const { t } = useTranslate('common')
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div>
      {name && label && (
        <label htmlFor={name} className="photon-label-sm pb-1.5 font-medium">
          {label}
          {required ? '*' : ''}
        </label>
      )}
      <div className="relative mt-1">
        <input
          ref={inputRef}
          type="date"
          id={name}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          required={required}
          min={min}
          max={max}
          disabled={disabled}
          className={classNames(
            'photon-paragraph-md w-full rounded-lg border p-2 !duration-[0ms] focus-visible:ring-0 focus-visible:ring-transparent focus-visible:ring-offset-0 focus-visible:ring-offset-transparent disabled:bg-white',
            error ? '!border-error-500' : 'border-core-gray-300',
          )}
          placeholder={t('monthFormat', 'mm/dd/yyyy')}
          aria-invalid={!!error}
          aria-describedby={error ? `${name}-error` : undefined}
        />
      </div>
      <CaptionXS role="alert" className="min-h-[20px]">
        {error ? (
          <span id={`${name}-error`} className="text-error-500">
            {error}
          </span>
        ) : (
          <span>&nbsp;</span>
        )}
      </CaptionXS>
    </div>
  )
}
